import brand from 'brands/p66'

const {
  accountNumberConfig,
  cardNumberConfig,
  palette,
  clientDetail,
  clientInfo,
  images,
  brandDocument,
  getMarketingBannerConfig,
  customComponents,
  translations,
  features,
  workStationConfig,
  cardActivation
} = brand

export {
  accountNumberConfig,
  cardNumberConfig,
  palette,
  clientInfo,
  clientDetail,
  images,
  brandDocument,
  getMarketingBannerConfig,
  customComponents,
  translations,
  features,
  workStationConfig,
  cardActivation
}
